// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__2euoR","content":"TermsOfServicePage_content__1HaUK"};